<span
	[class.rejected]="result.verification === false"
	[class.restored]="result.verification === true"
	[class.hovered]="isHovered()"
	[title]="result.createdAt | date:'HH:mm:ss'"
>{{result.microtime | laptimeFilter:'minutes'}}</span>
